var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"textarea",class:{ 'textarea--error': _vm.hasError },style:(_vm.style)},[_c('textarea',{ref:"textarea",staticClass:"textarea__input",attrs:{"data-cy":"textarea","disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})])
}
var staticRenderFns = []

export { render, staticRenderFns }